/**
 * Global RONR precedence ranks from RONR_taxonomy.md §2.
 * Higher number = higher precedence (rank 1 = Main motion, lowest).
 */

export const RONR_RANK_BY_KEY = {
  MAIN: 1,
  POSTPONE_INDEF: 2,
  AMEND: 3,
  COMMIT: 4,
  POSTPONE: 5,
  LIMIT_DEBATE: 6,
  PREVQ: 7,
  TABLE: 8,
  CALL_ORDERS: 9,
  QUESTION_PRIVILEGE: 10,
  RECESS: 11,
  ADJ: 12,
  FIX_HOUR: 13,
};

/**
 * Top of the logical meeting stack: current pending motion, or stack tail if no current.
 */
export function getTopPendingMotion(currentMotion, motionStack) {
  if (currentMotion) return currentMotion;
  const stack = motionStack || [];
  if (stack.length) return stack[stack.length - 1];
  return null;
}
